import * as slide from "../../assets/";

export const iniciativasDatasSlide = [
    {
        title: "Polo esportivo e cultural",
        information: "Visa proporcionar atividades educacionais e recreativas, utilizando de espaço público para realização das atividades de forma gratuita para pessoas com deficiência e suas famílias.",
        informationList:{
            title: "Principais atividades:",
            listItems: [
                "Aulas de skate adaptado",
                "Power soccer",
                "futebol",
                "Aulas de capoeira",
                "Peteca"
            ]
        },
        image:{
            src: slide.slide1,
            alt: "Imagem-slide1-Iniciativas",
            width: "405.19px",
            height: "500px"
        }
    },
    {
        title: "Polo cultural",
        information: "Atividades para que pessoas com e sem deficiência aprendam a colocar em prática as suas melhores atitudes e habilidades e tomar decisões de maneira responsável, tornando-se líderes saudáveis. ",
        informationList:{
            title: "Principais atividades:",
            listItems: [
                'Programa ”Eu lidero"',
                "Oficina do brincar",
                "Teatralização",
                "Contagem de histórias",
                "Oficina de horta"
            ]
        },
        image:{
            src: slide.slide2,
            alt: "Imagem-slide2-Iniciativas",
            width: "375px",
            height: "500px"
        }
    },
    {
        title: "Polo qualificação profissional",
        information: "O programa de desenvolvimento socioemocional Jovens Falcões tem o objetivo de desenvolver habilidades e competências socioemocionais que ajudem no preparo e qualificação dos jovens para facilitar sua inserção no mercado de trabalho. Além disso, temos como missão ensinar as mulheres e mães, cuidadoras de pessoas com deficiência a ter autonomia para usar as melhores competências para criar o seu próprio negócio. ",
        informationList:{
            title: "Principais atividades:",
            listItems: [
                "Qualificação profissional para jovens com e sem deficiência - Jovens Falcões",
                "Curso empreenda já",
            ]
        },
        image:{
            src: slide.slide3,
            alt: "Imagem-slide3-Iniciativas",
            width: "529px",
            height: "327px"
        }
    },
    {
        title: "Corrida e rua de lazer inclusiva",
        information: "Além da corrida de 5 km onde participam pessoas com e sem deficiência, o evento conta com diversas atividades como: palestras, oficina de atividades, brinquedos infláveis e inclusivos e tendas com informações de utilidade pública.",
        informationList:{
            title: "",
            listItems: [
                "",
                "",
            ]
        },
        image:{
            src: slide.slide4,
            alt: "Imagem-slide4-Iniciativas",
            width: "500px",
            height: "397px"
        }
    },
    {
        title: "Circuito nas escolas",
        information: "Uma conversa sobre inclusão, acessibilidade e diversidade, e a importância da inclusão, nas aulas de educação física escolar.",
        informationList:{
            title: "",
            listItems: [
                "",
                "",
            ]
        },
        image:{
            src: slide.slide5,
            alt: "Imagem-slide5-Iniciativas",
            width: "500px",
            height: "500px"
        }
    },
    {
        title: "Colônia de férias",
        information: "Proporciona as pessoas com deficiência momentos de brincadeiras durante as férias, para amenizar as crises de ansiedade, devido ao período de recesso.",
        informationList:{
            title: "",
            listItems: [
                "",
                "",
            ]
        },
        image:{
            src: slide.slide6,
            alt: "Imagem-slide6-Iniciativas",
            width: "500px",
            height: "498px"
        }
    },
    {
        title: "Bazar social",
        information: "Oferta de produtos, roupas e brinquedos, novos e seminovos a baixo custo, com o propósito de arrecadar fundos para os projetos sociais.",
        informationList:{
            title: "",
            listItems: [
                "",
                "",
            ]
        },
        image:{
            src: slide.slide7,
            alt: "Imagem-slide7-Iniciativas",
            width: "500px",
            height: "500px"
        }
    },
]

export const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
};
